import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyD-9HjK7MT1HJAU4juuc7lnPCqKvXL-UTk",
    authDomain: "wright-text.firebaseapp.com",
    databaseURL: "https://wright-text.firebaseio.com",
    projectId: "wright-text",
    storageBucket: "wright-text.appspot.com",
    messagingSenderId: "263785907414",
    appId: "1:263785907414:web:68332e5d7ba177de0ff577",
    measurementId: "G-WTKGWTEB8H"
});

const auth = firebase.auth()

export {
    auth
};